import { Navigate } from "react-router-dom";
import { useMe } from "../../hooks/useMe.js";
import { AdminSettings } from "../components/AdminSettings.jsx";
import { PageReveal } from "../components/PageReveal.jsx";

export function SettingsPage() {
  const { me, loading, isAdmin } = useMe();

  if (!loading && !isAdmin) return <Navigate to="/deals" replace />;

  const ready = !loading && !!me && isAdmin;
  return (
    <>
      <PageReveal ready={ready}>
        {ready ? <AdminSettings /> : null}
      </PageReveal>
    </>
  );
}

